import React from 'react';
import CountdownTimer from './CountdownTimer';
import './UnderConstruction.css';

const UnderConstruction = () => {
    return (
        <div className="container">
            <div className="banner">
                <h1>App Under Construction</h1>
                <p>We are working hard to bring you a better experience. Stay tuned!</p>
            </div>
            <CountdownTimer />
        </div>
    );
};

export default UnderConstruction;